/**
 * Stable reference for @react-google-maps/api useLoadScript / LoadScript.
 * Passing a new array each render triggers "LoadScript has been reloaded unintentionally".
 */
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry'];
